
import React, { useState } from 'react';


// Libraries
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Navigation, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Components
import PageHeader from '../../layouts/page-header/PageHeader';
import ServicesTabs from '../home4/tabs';

import SearchEngineOptimization from '../../template/search-engine-optimization';
import TabsPGS from '../../component/tabs/tabs';
import SectionTitle from '../../component/section-title/section-title';
import TabImage from '../../assets/images/about/08.webp';
import aboutImage2 from '../../assets/images/about/02.webp';
import FeatureInfo from '../../component/feature-info';
import DigitalStrategy2 from '../../template/digital-strategy-2';
import { Link } from 'react-router-dom';

import { FeatureTimeline } from '../../component/feature-step/feature-step';
import { InfoBox2 } from '../../component/infobox';
import { ActionBoxMini } from '../../component/action-box';

import DigitalImage1 from '../../assets/images/memeber/3.webp';
import DigitalImage2 from '../../assets/images/memeber/4.webp';
import DigitalImage3 from '../../assets/images/memeber/5.webp';
import DigitalImage4 from '../../assets/images/memeber/1.webp';
import DigitalImage5 from '../../assets/images/memeber/2.webp';


import Services from '../../component/services/services-item';

const ServicesList = [
  {
    id: 1,
    imgsrc: DigitalImage1,

    title: "Mesurer et réduire l'empreinte carbone",
    description:
"Ils ont présenté les bonnes pratiques et les outils permettant aux entreprises d'évaluer et de diminuer leur impact environnemental."
},
  {
    id: 2,
    imgsrc: DigitalImage2,

    title: "L'importance du bilan carbone",
    description:
"L'importance de réaliser un bilan carbone a été expliquée, ainsi que la manière de l'utiliser pour mieux comprendre l'empreinte environnementale d'une activité."
},
  {
    id: 3,
    imgsrc: DigitalImage3,

    title: 'Les critères ESG ',
    description:
    "Les experts ont détaillé la manière d'intégrer les critères Environnement, Social et Gouvernance (ESG) dans la stratégie des entreprises afin de répondre aux enjeux sociétaux et environnementaux."

}
];


const Tab = [
    {
        img: aboutImage2,
        title: "Identification des opportunités",
        text: "Détection des opportunités commerciales et d'investissement adaptées aux besoins spécifiques de votre entreprise."
    },
    {
        img: aboutImage2,
        title: "Études de marché",
        text: "Réalisation d’études de marché approfondies pour vous fournir des informations pertinentes et à jour sur les tendances du marché, les concurrents et les conditions économiques."
    },
    {
        img: aboutImage2,
        title: "Mise en relation",
        text: "Facilitation des contacts stratégiques avec des partenaires potentiels, des clients, des fournisseurs et des institutions locales. Accès des contacts privilégiés dans les secteurs clés."
    },
    {
        img: aboutImage2,
        title: "Conseils personnalisés",
        text: "Sessions de consultation individuelles pour discuter de vos objectifs, de vos défis et des solutions possibles. Offre de conseils sur les stratégies d'entrée sur le marché, les démarches réglementaires, les options de financement et les meilleures pratiques commerciales."
    },
    {
        img: aboutImage2,
        title: "Organisation de visites et de rencontres",
        text: "Organisation de visites d'entreprises, de rencontres B2B et d'événements de networking pour faciliter l'intégration et l'expansion sur le marché."
    }
]

const Tab2 = [{
    img: aboutImage2,
    title: "Faciliter l'entrée sur le marché",
    text: "Aider les entreprises à naviguer dans les complexités des nouveaux marchés, en fournissant des informations cruciales et des contacts locaux pour une entrée réussie."
},
{
    img: aboutImage2,
    title: "Optimiser les opportunités de croissance",
    text: "Identifier et exploiter les opportunités de croissance pour maximiser le potentiel commercial et les rendements financiers."
},
{
    img: aboutImage2,
    title: "Réduire les risques",
    text: "Minimiser les risques associés à l'expansion internationale grâce à une connaissance approfondie du marché et à un accompagnement stratégique."
},
{
    img: aboutImage2,
    title: "Accélérer le développement des affaires",
    text: "Favoriser un développement rapide et efficace des affaires par un soutien constant et des interventions ciblées."
},
{
    img: aboutImage2,
    title: "Renforcer la compétitivité",
    text: "Augmenter la compétitivité de nos membres en leur fournissant des outils, des ressources et des connaissances spécifiques au marché."
}]

function Engagements() {
    return (
        <>
            <div className="site-content">
                <PageHeader
                    title="Engagement RSE"
                    breadCrumbItems={[
                        { label: 'Accueil', path: '/' },
                        // { label: 'Engagement RSE', path: '#', active: true },
                    ]}
                />
                <div className="content-wrapper">
                    <section className="section-pt">
                        <Container>
                            <Row className="align-items-center digitalstrategy-content">
                                <Col lg={7} className="mb-4 mb-lg-0">

                                    <h3 className="mb-4">Notre engagement en responsabilité sociétale des entreprises (RSE)                                    </h3>
                                    <p className="mb-4">
                                        À la Chambre de Commerce et d'Industrie Tuniso-Suisse, nous croyons fermement que le succès économique et le bien-être social sont indissociables. Notre engagement en matière de responsabilité sociétale des entreprises (RSE) est au cœur de nos actions et de nos initiatives, visant à créer un impact positif durable sur la communauté et l'environnement.
                                    </p>

                                </Col>
                                <Col lg={5}>
                                    <img className="img-fluid" src={DigitalImage4} alt="" />
                                </Col>
                            </Row>
                        </Container>
                    </section>

                    <section className="section-pt">
                        <Container>
                            <Row className="align-items-center digitalstrategy-content">

                                <Col lg={5}>
                                    <img className="img-fluid" src={DigitalImage5} alt="" />
                                </Col>
                                <Col lg={7} className="mb-4 mb-lg-0">

                                    <h3 className="mb-4">Événements spéciaux : Sensibilisation et inclusion                                    </h3>
                                    <p className="mb-4">
                                        Pour illustrer notre engagement, nous organisons des événements uniques comme le "Dîner dans la pénombre". Cet événement a pour objectif de sensibiliser les participants aux défis rencontrés par les personnes non-voyantes. Pour rendre cette expérience encore plus significative, le service et la préparation des plats sont assurés par des personnes autistes. Cette initiative vise non seulement à sensibiliser, mais aussi à promouvoir l'inclusion sociale et professionnelle des personnes en situation de handicap.
                                    </p>

                                    
                                </Col>

                            </Row>
                        </Container>
                    </section>

                    <section className="section-ptb">
                        <Container>
                            
                            <Row>
                                <Col sm={12}>
                                    <div className="service-wrapper grid-wrapper grid-lg-3 grid-md-2 grid-sm-1">
                                        {ServicesList.map((val, ind) => {
                                            return (
                                                <Services
                                                    key={ind}
                                                    theme="feature-info-style-02"
                                                    imgsrc={val.imgsrc}
                                                    icon={val.icon}
                                                    title={val.title}
                                                    description={val.description}
                                                    id={val.id}
                                                    servicesurl={val.servicesurl}
                                                />
                                            );
                                        })}
                                    </div>
                                </Col>
                            </Row>
                            {/* <Row className="mt-5">
                                <Col sm={12} className="d-md-flex justify-content-center">
                                    <ActionBoxMini
                                        btnClass="btn-primary-round"
                                        content="Start now! Your big opportunity may be right where you are!"
                                        btnText="See All Services"
                                        btnURL="/service"
                                    />
                                </Col>
                            </Row> */}
                        </Container>
                    </section>

                    <section className="section-ptb">
                        <Container>
                            <Row>
                                <Col md={6} className="mb-5 mb-md-0">
                                    <div className="sticky-top custom-sticky">
                                        <SectionTitle
                                            title="Nos actions RSE "
                                            manyContent={["Nous restons pleinement engagés pour accompagner nos membres vers un avenir plus vert et responsable ! "]}
                                        />
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <Valeur />
                                </Col>
                            </Row>
                        </Container>
                    </section>

                    <section className="">
                        <Container>
                            <Row className="justify-content-center">
                                <Col xl={9} lg={10}>
                                    <SectionTitle
                                        extraClass="text-center"
                                        title="Impact de notre engagement"
                                        manyContent={["En tant que membre de la Chambre de Commerce et d'Industrie Tuniso-Suisse, vous rejoignez une organisation qui place la responsabilité sociale au cœur de ses préoccupations. Ensemble, nous pouvons continuer à bâtir un monde plus équitable, inclusif et durable."]}
                                        linkName="Devenir un membre "
                                        link = "/devenir-membre"
                                    />
                                </Col>
                            </Row>
                            <StrategySection />
                        </Container>
                    </section>

                </div>
            </div>
        </>
    );
}

export default Engagements;



const Valeur = () => {

    const FeatureTimelineList = [
        {
            id: 1,
            stepNumber: '01',
            title: 'Promotion de l’inclusion',
            description: "Nous travaillons activement à l'inclusion des personnes en situation de handicap dans le milieu professionnel. Nos événements et programmes sont conçus pour créer des opportunités et valoriser les compétences de chacun, indépendamment de leurs capacités.La Chambre de Commerce et d’Industrie Tuniso Suisse est fière d'être partenaire de la startup",
            link : "https://www.facebook.com/handisuccess/?locale=fr_FR",
            linkName : "Handisuccess International"
        },
        {
            id: 2,
            stepNumber: '02',
            title: 'Engagement environnemental',
            description: "La chambre met en œuvre des pratiques écologiques pour minimiser notre empreinte carbone. Nous encourageons nos membres à adopter des solutions durables et organisons des ateliers et des formations sur les meilleures pratiques environnementales."
        },
        {
            id: 3,
            stepNumber: '03',
            title: 'Développement communautaire',
            description: "Nous collaborons avec des associations locales et des ONG pour soutenir des projets qui améliorent la qualité de vie dans nos communautés. Nos membres sont encouragés à participer activement à ces initiatives, renforçant ainsi notre impact collectif."
        },
        {
            id: 4,
            stepNumber: '04',
            title: 'Éducation et sensibilisation',
            description: "Nous croyons en l'importance de l'éducation et de la sensibilisation pour un avenir meilleur. Nos campagnes de communication et nos événements visent à informer et à inspirer les entreprises et les individus à adopter des pratiques responsables."
        },
        {
            id: 5,
            stepNumber: '05',
            title: 'Soutien aux petites entreprises et entrepreneurs sociaux',
            description: "Nous apportons un soutien particulier aux petites entreprises et aux entrepreneurs sociaux, leur offrant des plateformes de visibilité et des opportunités de réseautage pour encourager l'innovation et l'entrepreneuriat responsable."
        }
    ];



    return (
        <>
            <div className="feature-step-wrapper">
                {FeatureTimelineList.map((val, ind) => {
                    if (ind < 4) {
                        return (
                            <FeatureTimeline
                                key={ind}
                                extraClass=""
                                featureImg={val.featureImg}
                                stepNumber={val.stepNumber}
                                title={val.title}
                                description={val.description}
                                linkName = {val.linkName}
                                link = {val.link}
                            />
                        );
                    }
                    // Default return statement
                    return null;
                })}
            </div>
        </>
    );
}

function StrategySection() {
    return (
        <>
            <Row>
                <Col md={3} className="mb-4 mb-md-0">
                    <InfoBox2
                        icon="flaticon-idea-1"
                        line="none"
                        description="Sensibiliser des centaines de personnes aux réalités des non-voyants et des personnes autistes."
                    />
                </Col>
                <Col md={3} className="mb-4 mb-md-0">
                    <InfoBox2
                        icon="flaticon-diamond"
                        line="none"
                        description="Réduire notre empreinte carbone collective en adoptant des pratiques durables."
                    />
                </Col>
                <Col md={3} className="mb-4 mb-md-0">
                    <InfoBox2

                        icon="flaticon-rocket"
                        line="none"
                        description="Favoriser l'inclusion de personnes en situation de handicap dans le monde du travail."
                    />
                </Col>
                <Col md={3} className="mb-4 mb-md-0">
                    <InfoBox2
                        line="none"
                        icon="flaticon-rocket"

                        description="Soutenir des projets communautaires qui ont amélioré la vie de nombreuses familles.."
                    />
                </Col>
            </Row>
            <Row className="mt-5 pt-2">
                <Col sm={12} className=" digitalstrategy-content">
                    {/* <ActionBoxMini
                        btnClass="btn-primary-round"
                        content="Ensemble, nous pouvons continuer à bâtir un monde plus équitable, inclusif et durable. Ajouter le lien de devenir membre "
                      
                    /> */}
                    <p>Ensemble, nous pouvons continuer à bâtir un monde plus équitable, inclusif et durable.</p>
                    <br/>
                    <Link className="btn btn-light btn-sm mt-3" to="mailto:chambretunisosuisse@gmail.com">
                        En savoir plus
                    </Link> 
                </Col>
            </Row>
        </>
    );
}